import { privateAxios } from 'services/api/privateAxios';

export const getDriverOrder = id =>
  privateAxios({
    method: 'get',
    url: `/orderboard/${id}`,
  });
